import React from "react";

const TradeHistory = () => {
  return (
    <div
      style={{
        paddingBottom: "24px",
        position: "relative",
      }}
    >
      <div
        style={{
          color: "white",
          fontSize: "16px",
          fontWeight: "600",
          backgroundColor: "#1B1F2D",
          width: "100%",
          padding: "16px 24px",
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          display: "flex",
          gap: "32px",
          position: "sticky",
          top: "0",
          zIndex: "999",
          left: "0",
        }}
      >
        <p>Open Trades</p>
        <p style={{ color: "#ACB3CD" }}>Closed Trades</p>
      </div>

      <table
        style={{
          // backgroundColor: "red",
          width: "100%",
        }}
      >
        <th
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            padding: "12px 24px",
            fontSize: "14px",
            fontWeight: "500",
            color: "#ACB3CD",
            alignItems: "center",
          }}
        >
          <td style={{ maxWidth: "300px", width: "100%", textAlign: "left" }}>
            <p>Asset</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Date</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Direction</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Amount</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Entry price</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>P&L</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Action</p>
          </td>
        </th>
        <hr style={{ border: "1px solid #212945" }} />
        <tr
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "500",
            color: "white",
            alignItems: "center",
          }}
        >
          <td style={{ maxWidth: "300px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                BTC/USD
              </p>
            </span>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>June 5</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Buy</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                3 BTC
              </p>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
            </span>
            {/* <p>3 BTC</p> */}
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$25,393.42</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$100</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <button
              style={{
                outline: "none",
                backgroundColor: "transparent",
                border: "1px solid #ACB3CD",
                color: "white",
                fontSize: "14px",
                padding: "8px 16px",
                borderRadius: "12px",
                fontWeight: "600",
              }}
            >
              Close
            </button>
          </td>
        </tr>

        <tr
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "500",
            color: "white",
            alignItems: "center",
          }}
        >
          <td style={{ maxWidth: "300px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                BTC/USD
              </p>
            </span>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>June 5</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Buy</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                3 BTC
              </p>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
            </span>
            {/* <p>3 BTC</p> */}
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$25,393.42</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$100</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <button
              style={{
                outline: "none",
                backgroundColor: "transparent",
                border: "1px solid #ACB3CD",
                color: "white",
                fontSize: "14px",
                padding: "8px 16px",
                borderRadius: "12px",
                fontWeight: "600",
              }}
            >
              Close
            </button>
          </td>
        </tr>

        <tr
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "500",
            color: "white",
            alignItems: "center",
          }}
        >
          <td style={{ maxWidth: "300px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                BTC/USD
              </p>
            </span>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>June 5</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Buy</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                3 BTC
              </p>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
            </span>
            {/* <p>3 BTC</p> */}
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$25,393.42</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$100</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <button
              style={{
                outline: "none",
                backgroundColor: "transparent",
                border: "1px solid #ACB3CD",
                color: "white",
                fontSize: "14px",
                padding: "8px 16px",
                borderRadius: "12px",
                fontWeight: "600",
              }}
            >
              Close
            </button>
          </td>
        </tr>

        <tr
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "500",
            color: "white",
            alignItems: "center",
          }}
        >
          <td style={{ maxWidth: "300px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                BTC/USD
              </p>
            </span>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>June 5</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Buy</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                3 BTC
              </p>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
            </span>
            {/* <p>3 BTC</p> */}
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$25,393.42</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$100</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <button
              style={{
                outline: "none",
                backgroundColor: "transparent",
                border: "1px solid #ACB3CD",
                color: "white",
                fontSize: "14px",
                padding: "8px 16px",
                borderRadius: "12px",
                fontWeight: "600",
              }}
            >
              Close
            </button>
          </td>
        </tr>

        <tr
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "500",
            color: "white",
            alignItems: "center",
          }}
        >
          <td style={{ maxWidth: "300px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                BTC/USD
              </p>
            </span>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>June 5</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Buy</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                3 BTC
              </p>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
            </span>
            {/* <p>3 BTC</p> */}
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$25,393.42</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$100</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <button
              style={{
                outline: "none",
                backgroundColor: "transparent",
                border: "1px solid #ACB3CD",
                color: "white",
                fontSize: "14px",
                padding: "8px 16px",
                borderRadius: "12px",
                fontWeight: "600",
              }}
            >
              Close
            </button>
          </td>
        </tr>

        <tr
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "500",
            color: "white",
            alignItems: "center",
          }}
        >
          <td style={{ maxWidth: "300px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                BTC/USD
              </p>
            </span>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>June 5</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>Buy</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <p
                style={{ fontSize: "16px", color: "white", fontWeight: "600" }}
              >
                3 BTC
              </p>
              <img
                src="./assets/asset/bitcoin.svg"
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
            </span>
            {/* <p>3 BTC</p> */}
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$25,393.42</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <p>$100</p>
          </td>
          <td style={{ maxWidth: "200px", width: "100%", textAlign: "left" }}>
            <button
              style={{
                outline: "none",
                backgroundColor: "transparent",
                border: "1px solid #ACB3CD",
                color: "white",
                fontSize: "14px",
                padding: "8px 16px",
                borderRadius: "12px",
                fontWeight: "600",
              }}
            >
              Close
            </button>
          </td>
        </tr>
      </table>
    </div>
  );
};

export default TradeHistory;
